<div class="relative flex flex-col items-center rounded-[20px] bg-background-white drop-shadow-lg">
  <div class="flex justify-center p-2">
    <button
      (click)="reviewClick.emit()"
      type="button"
      class="mr-2 flex flex-col items-center justify-center gap-1 rounded-xl border-2 border-background-light-grey px-5 py-2"
      [class.bg-background-light-blue]="isReviewActive()"
    >
      <svg-icon class="text-text-blue" key="px-24-fullmouth"></svg-icon>
      <span class="text-h7 font-semibold text-text-blue">{{ 'perio_exam_toolbar_review' | translate }}</span>
    </button>

    <div class="mr-2 flex flex-col items-center justify-center px-3.5">
      <lib-perio-position-indicator [toothList]="toothList()" (toothNavigate)="onToothNavigate($event)"></lib-perio-position-indicator>
    </div>
    <button
      #audioInputOverlay
      (click)="voiceToggle.emit()"
      type="button"
      [class.bg-other-light-purple]="isVoiceActive() || isVoiceLoading()"
      class="relative flex flex-col items-center justify-center gap-1 rounded-xl border-2 border-background-light-grey px-5 py-2"
    >
      <button
        type="button"
        class="absolute right-1 top-1 flex h-5 w-5 items-center justify-center rounded-full bg-background-light-grey"
        (click)="onMicSettingsToggle(); $event.stopPropagation()"
        [attr.aria-label]="'Open microphone settings'"
      >
        <svg-icon [key]="dropdownIcon" size="sm" class="text-background-purple" />
      </button>

      <ng-lottie
        *ngIf="isVoiceLoading()"
        size="small"
        currentcolor
        class="h-4 w-4 text-background-purple"
        [options]="lottieOptions"
      ></ng-lottie>
      @if (!isVoiceLoading() && isVoiceActive()) {
        <div class="relative flex h-6 w-6 items-center justify-center">
          <svg-icon class="absolute z-10 h-6 w-6 shrink-0 text-background-purple" [key]="'px-24-voice'" size="md"></svg-icon>
          <div class="absolute top-[1px] z-0 h-[14px] w-2 -scale-y-100 overflow-hidden rounded-full">
            <div class="h-3 w-2 bg-background-green" [style.height]="volumeLevelPercent()"></div>
          </div>
        </div>
      }
      @if (!isVoiceLoading() && !isVoiceActive()) {
        <svg-icon class="text-background-purple" key="px-24-voice-muted"></svg-icon>
      }

      <span class="text-h7 font-semibold text-background-purple">{{ isVoiceActive() ? 'Voice ON' : 'Voice OFF' }}</span>
    </button>
  </div>
  @if (tutorialOpened()) {
    <lib-perio-exam-tutorial @expand (handleClose)="onTutorialClose()" />
  }
  <div
    class="tutorial-toggler absolute bottom-0 -mb-8 flex h-8 cursor-pointer items-center justify-center gap-2 rounded-b-2xl bg-states-white px-3 backdrop-blur-modal"
    (click)="onTutorialClick()"
  >
    <span class="typo-h7-light"> {{ 'perio_exam_tutorial_label' | translate }} </span>
    <svg-icon
      [ngClass]="{
        'rotate-180': tutorialOpened()
      }"
      key="px-16-arrow-down"
      size="sm"
      class="text-text-blue transition-all duration-300"
    />
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayOrigin]="audioInputOverlay"
  [cdkConnectedOverlayOpen]="audioInputDropdownIsOpen()"
  (backdropClick)="onBackdropClick()"
>
  <div class="relative w-[320px] rounded-3xl bg-background-white/50 p-4 shadow-card backdrop-blur">
    <ffd-audio-device-list
      #microphoneDeviceDropdown
      [formControl]="selectedDeviceControl"
      class="mb-4 w-full rounded-2xl border border-text-white"
      [builtInDevices]="builtInDevices()"
      [connectedDevices]="[]"
      [labelText]="'audio_input_switcher_description' | translate"
    />
    <div class="flex justify-end gap-10">
      <button type="button" class="btn-primary" (click)="onDone()">{{ 'audio_input_error_modal_done' | translate }}</button>
    </div>
  </div>
</ng-template>
